<template>
    <div class="grafico-container">
        <div class="grafico-header">
            <h3 class="grafico-titulo">HP por Responsável</h3>
            <GraficoInfoIcon 
                titulo="HP por Responsável"
                descricao="Mostra a distribuição de horas planejadas (HP) por responsável, identificando a carga de trabalho de cada pessoa."
            />
        </div>
        <div v-if="!temDados" class="sem-dados">Nenhum dado disponível</div>
        <Bar v-else :data="chartData" :options="chartOptions" />
    </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import GraficoInfoIcon from './GraficoInfoIcon.vue';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default {
    name: 'GraficoHPPorResponsavel',
    components: { Bar, GraficoInfoIcon },
    props: {
        projetos: {
            type: Array,
            default: () => []
        }
    },
    emits: ['clicar-projeto'],
    computed: {
        dadosPorResponsavel() {
            const responsaveisMap = {};
            
            this.projetos.forEach(projeto => {
                if (projeto.entregas && Array.isArray(projeto.entregas)) {
                    projeto.entregas.forEach(entrega => {
                        if (entrega.sprints && Array.isArray(entrega.sprints)) {
                            entrega.sprints.forEach(sprint => {
                                if (sprint.tarefas && Array.isArray(sprint.tarefas)) {
                                    sprint.tarefas.forEach(tarefa => {
                                        if (tarefa.responsavel && tarefa.HP) {
                                            const nome = tarefa.responsavel.name || 'Sem responsável';
                                            if (!responsaveisMap[nome]) {
                                                responsaveisMap[nome] = { nome, hp: 0 };
                                            }
                                            responsaveisMap[nome].hp += parseFloat(tarefa.HP || 0);
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
            
            return Object.values(responsaveisMap)
                .sort((a, b) => b.hp - a.hp)
                .slice(0, 15);
        },
        temDados() {
            return this.dadosPorResponsavel.length > 0;
        },
        chartData() {
            const dados = this.dadosPorResponsavel;
            return {
                labels: dados.map(d => d.nome.length > 20 ? d.nome.substring(0, 20) + '...' : d.nome),
                datasets: [{
                    label: 'HP',
                    data: dados.map(d => d.hp),
                    backgroundColor: 'rgba(54, 117, 211, 0.6)',
                    borderColor: 'rgba(54, 117, 211, 1)',
                    borderWidth: 2
                }]
            };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y',
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                return `HP: ${context.parsed.x.toFixed(1)}h`;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: 'Horas Planejadas (HP)'
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Responsáveis'
                        }
                    }
                }
            };
        }
    }
};
</script>

<style scoped>
.grafico-container {
    background: var(--cor-bg, white);
    border: 1px solid var(--cor-separador, #ddd);
    border-radius: 8px;
    padding: 1.5rem;
    height: 600px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
}

.grafico-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.grafico-titulo {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--cor-fonte, #333);
}

.sem-dados {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
}
</style>

